<div class="d-flex justify-content-center align-items-center flex-column" style="width: 100%; height: 100%">
  <h3 class="">Redirecting...</h3>

  <br />
  <br />
  <br />
</div>
